export default __webpack_public_path__ + "static/media/correct.160572d7.mp3";